import { createI18n } from "vue-i18n";

// Import language files
import en from "@/locales/en.json";
import ar from "@/locales/ar.json";
import am from "@/locales/am.json";
import fa from "@/locales/fa.json";
import fr from "@/locales/fr.json";

const messages = {
  en,
  ar,
  am,
  fa,
  fr,
};

const i18n = createI18n({
  locale: "en",
  fallbackLocale: "en",
  messages,
});

export default i18n;
